const getBase64File = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve((reader as any).result.split('base64,')[1]);
    reader.onerror = (error) => reject(error);
  });

export default getBase64File;
